import Singleton from '../Singleton';
import ApiService from '../_shared/api/apiService';

export default class TradeCountService extends Singleton<TradeCountService> {
  static getTradeCount = async (context?: number) => {
    let response;
    try {
      const client = await ApiService();
      response = await client.apis.trade.countTrades({
        request: {
          request: { context }
        }
      });
    } catch (error) {
      return error?.response?.data;
    }
    return response;
  };
}
